/**
 * Content types allowed for resume uploads and processing.
 */
export const RESUME_UPLOAD_CONTENT_TYPES = [
  // PDF
  'application/pdf',
  // Office documents
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'application/rtf',
  'text/rtf',
  'text/plain',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.oasis.opendocument.spreadsheet',
  'text/csv',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.oasis.opendocument.presentation',
  // Images
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'image/x-tiff',
  // Markdown
  'text/markdown',
  'text/x-markdown',
] as const

/**
 * Convenience set for runtime validation (case-insensitive).
 */
export const RESUME_UPLOAD_CONTENT_TYPE_SET = new Set(
  RESUME_UPLOAD_CONTENT_TYPES.map(type => type.toLowerCase())
)

/**
 * Comma-separated accept string for file inputs/dropzones.
 */
export const RESUME_UPLOAD_ACCEPT = RESUME_UPLOAD_CONTENT_TYPES.join(', ')
